import type { DeleteCustomDatasourceMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteCustomDatasourceDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteCustomDatasource = createMutationHook({
  name: 'deleteCustomDatasource',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.customDatasource.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Id: string }) => ({ Id: variables.Id }),
  invalidate: (trpc) => [
    trpc.frontend.customDatasource.customDatasources.queryKey(),
    trpc.frontend.customDatasource.customDatasourceById.queryKey(),
  ],
  // The legacy `delete_custom_datasource_by_pk` returned the deleted row's
  // Id; the tRPC service resolves void, so we surface `null` (the caller —
  // the DeleteModal — does not read the returned Id).
  mapResponse: (): DeleteCustomDatasourceMutation => ({
    delete_custom_datasource_by_pk: null,
  }),
  graphqlDocument: DeleteCustomDatasourceDocument,
  // mirrors the legacy cache eviction on the two custom_datasource query families.
  graphqlVariables: (variables: { Id: string }) => ({ Id: variables.Id }),
  evictFields: ['custom_datasource', 'custom_datasource_by_pk'],
});
